export default "__VITE_ASSET__D1ougX4a__";